import { Building2, ChevronRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Navigate, useNavigate } from "react-router";
import { Brand } from "@/components/brand";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/lib/auth";

export function SelectTenantPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { memberships, membershipsLoading, tenant, switchTenant, signOut } = useAuth();
  if (tenant) return <Navigate to="/" replace />;

  return (
    <div className="mx-auto flex min-h-dvh max-w-md flex-col justify-center gap-6 px-6">
      <Brand />
      <div className="space-y-1.5">
        <h1 className="text-2xl font-semibold">{t("auth.select_tenant")}</h1>
        <p className="text-sm text-muted-foreground">{memberships.length === 0 && !membershipsLoading ? t("auth.no_tenant") : t("auth.select_tenant_hint")}</p>
      </div>
      <ul className="space-y-2">
        {memberships.map((m) => (
          <li key={m.tenant_id}>
            <button
              onClick={() => {
                switchTenant(m.tenant_id);
                navigate("/");
              }}
              className="flex w-full items-center gap-3 rounded-xl border bg-card p-4 text-left hover:border-foreground/20"
            >
              <Building2 className="size-5 text-muted-foreground" />
              <span className="flex-1">
                <span className="block font-medium">{m.tenant_name}</span>
                <span className="block text-xs text-muted-foreground">{m.roles.map((r) => t(`roles.${r}`)).join(" · ")}</span>
              </span>
              <ChevronRight className="size-4 text-muted-foreground" />
            </button>
          </li>
        ))}
      </ul>
      <Button variant="ghost" onClick={() => void signOut()}>
        {t("auth.sign_out")}
      </Button>
    </div>
  );
}
